import {
  mergeFieldValues,
  unwrapFieldValue,
  wrapFields,
} from 'features/libra/ontology/ontologyFieldDefaults'
import { FieldValues } from 'features/libra/ontology/ontologyFieldTypes'
import { ELIGIBILITY_STATUS } from 'features/libra/types/eligibility'

import { StepBranchConfig, StepBranchTarget } from './workflowStepsApi'

/**
 * Mapped screening workflows branch on the published `eligibility` enum, not
 * the `nii_eligible_computed` boolean, so the enum values coerce to the same
 * true/false arms.
 */
export function coerceBranchValue(raw: unknown): boolean | undefined {
  if (typeof raw === 'boolean') return raw
  if (raw === ELIGIBILITY_STATUS.ELIGIBLE) return true
  if (raw === ELIGIBILITY_STATUS.NOT_ELIGIBLE) return false
  return undefined
}

export function resolveStepBranchTarget(
  branch: StepBranchConfig | undefined,
  fieldValues: FieldValues,
  fallbackTarget?: StepBranchTarget
): StepBranchTarget | undefined {
  if (!branch) {
    return fallbackTarget
  }

  const branchValue = coerceBranchValue(
    unwrapFieldValue(fieldValues[branch.field])
  )
  if (branchValue === true) {
    return branch.whenTrue ?? fallbackTarget
  }
  if (branchValue === false) {
    return branch.whenFalse ?? fallbackTarget
  }
  return fallbackTarget
}

export function applyStepBranchSetFields(
  branch: StepBranchConfig | undefined,
  fieldValues: FieldValues
): FieldValues {
  const setFields = resolveStepBranchTarget(branch, fieldValues)?.setFields
  if (!setFields) return fieldValues

  return mergeFieldValues(fieldValues, wrapFields(setFields))
}
